import React from 'react';
import ReactDOM from 'react-dom';
import ServiceLetters from './service-letters.jsx';
import ServiceContainer from './service-container.jsx';

import { populate } from './../utils/populate.js';

class Services extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      endpoint: '/rest/services?_format=json',
      data : []
    };

    this.populateAll = this.populateAll.bind(this);
  }

  componentDidMount() {
    this.populateAll();
  }

  populateAll() {
    const { endpoint } = this.state;
    const that = this;
    populate(endpoint).then(function( response ){
      const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
      let results = [];

      for (let o = 0; o < letters.length; o++) results.push({
        letter: letters[o],
        services: []
      });

      for (let i = 0; i < response.length; i++) {
        let s = letters.indexOf(response[i].letter);
        results[s].services.push({
          title: response[i].name,
          url: response[i].url
        })
      }
      that.setState({
        data: results
      })
    });
  }

  render() {
    const { data } = this.state;

    if(data.length !== 0){
      return(
        <div id="browse--services" className="browse--services">
          <ul className="letter--select flex flex__between list__presentational">
            {
              data.map(el => {
                return (
                  <ServiceLetters key={el.letter} letter={el.letter} services={el.services} />
                );
              })
            }
          </ul>
          <div className="letter-details">
            {
              data.map(el => {
                if(el.services.length !== 0){
                  return (
                    <ServiceContainer key={el.letter} letter={el.letter} services={el.services} />
                  );
                }
                return null;
              })
            }
          </div>
        </div>
      )
    }else{
      return null;
    }
  }
}

if ( document.getElementById('react--browse--services') ) {

  ReactDOM.render(
    <Services/>,
    document.getElementById('react--browse--services')
  );

}









